export default __webpack_public_path__ + "8188bd468706eaa9c932b3e474207e84.png";